import { Helmet } from 'react-helmet';
import { ContainerComponent, SubtitleComponent, TitleComponent } from '../../components';
import './evChargingStations.styles.scss';
import { Trans, useTranslation } from 'react-i18next';
import StationImage from '../../assets/images/chargingStations.jpg'

function EvChargingStations() {
    const { t, i18n } = useTranslation();

    return (
        <div className='evChargingStations'>
            <Helmet>
                <title>{t('evChargingStations.meta.title')}</title>
                <meta name="description" content={t('evChargingStations.meta.description')} />
            </Helmet>
            <ContainerComponent>
                <Trans>
                    <h1><TitleComponent centered smaller>{t('evChargingStations.title')}</TitleComponent></h1>
                    <div className="evChargingStationsText">
                        <SubtitleComponent>{t('evChargingStations.offer')}</SubtitleComponent>
                        <div className="points">
                            <ul>
                                <li><h4><SubtitleComponent>{t('evChargingStations.subtitles.0')}</SubtitleComponent></h4></li>
                                <li><h4><SubtitleComponent>{t('evChargingStations.subtitles.1')}</SubtitleComponent></h4></li>
                                <li><h4><SubtitleComponent>{t('evChargingStations.subtitles.2')}</SubtitleComponent></h4></li>
                                <li><h4><SubtitleComponent>{t('evChargingStations.subtitles.3')}</SubtitleComponent></h4></li>
                                <li><h4><SubtitleComponent>{t('evChargingStations.subtitles.4')}</SubtitleComponent></h4></li>
                            </ul>
                        </div>
                    </div>
                    <div className="imageContainer">
                        <img src={StationImage} alt="EV charging station image" />
                    </div>
                </Trans>
            </ContainerComponent>
        </div>
    )
}

export default EvChargingStations